/**
 * Configuration for the Contains API
 */
export default {
	id: 'containsV2',
	name: 'Contains',
	resultsTitle: 'Recommendations',
	version: 'v2',
	fields: [
		{
			name: 'Facets',
			placeholder: '',
			required: true,
			value: null,
			id: 'facets',
			type: 'facets',
		},
		{
			name: 'Order By',
			required: false,
			value: 'Relevance',
			id: 'orderBy',
			type: 'select',
			options: [
				{
					value: 'Relevance',
					name: 'Relevance',
				},
				{
					value: 'PublishedDate',
					name: 'Published Date',
				},
				{
					value: 'Popularity',
					name: 'Popularity',
				},
				{
					value: 'Popularity7Days',
					name: 'Popularity 7 Days',
				},
				{
					value: 'Popularity30Days',
					name: 'Popularity 30 Days',
				},
				{
					value: 'LastUpdatedDate',
					name: 'Last Updated Date',
				},
				{
					value: 'LastOptimizedDate',
					name: 'Most recently optimized if newer than published first',
				},
				{
					value: 'AverageRating',
					name: 'Content ordered by average rating from high to low',
				},
				{
					value: 'ReviewsCount',
					name: 'Content ordered by reviews count from high to low',
				},
			],
		},
		{
			name: 'Content-types',
			placeholder: 'Enter content types...',
			required: false,
			value: null,
			id: 'docTypeFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/types',
		},
		{
			name: 'Sources',
			placeholder: 'Enter sources...',
			required: false,
			value: null,
			id: 'sourceFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/brands',
		},
		{
			name: 'Variants',
			placeholder: 'Enter variants...',
			required: false,
			value: null,
			id: 'variantFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/variants',
		},
		{
			name: 'Meredith User Id',
			placeholder: 'Enter User Id',
			required: false,
			value: '',
			id: 'muid',
			type: 'text',
		},
		{
			name: 'Exclude',
			placeholder: 'Enter excluded ids...',
			required: false,
			value: null,
			id: 'excludeIds',
			type: 'csv',
		},
		{
			name: 'Syndicated',
			required: false,
			id: 'syndicated',
			type: 'select',
			options: [
				{
					value: 'All',
					name: 'All',
				},
				{
					value: 'BrandExclusive',
					name: 'BrandExclusive',
				},
				{
					value: 'DoNotSyndicate',
					name: 'DoNotSyndicate',
				},
				{
					value: 'Branded',
					name: 'Branded',
				},
				{
					value: 'Native',
					name: 'Native',
				},
				{
					value: 'ExternalOnly',
					name: 'ExternalOnly',
				},
				{
					value: 'None',
					name: 'None',
				},
				{
					value: 'ContentLicensing',
					name: 'ContentLicensing',
				},
				{
					value: 'Unknown',
					name: 'Unknown',
				},
			],
		},
		{
			name: 'Exclude Affiliate Content',
			placeholder: '',
			required: false,
			value: false,
			id: 'excludeAffiliateContent',
			type: 'bool',
		},
		{
			name: 'Start Date',
			placeholder: 'Click to select a start date',
			required: false,
			value: null,
			id: 'startDate',
			type: 'datetime',
		},
		{
			name: 'End Date',
			placeholder: 'Click to select an end date',
			required: false,
			value: null,
			id: 'endDate',
			type: 'datetime',
		},
		{
			name: 'Page',
			placeholder: 'Page',
			required: false,
			value: 1,
			id: 'page',
			type: 'page',
		},
		{
			name: 'Page Size',
			placeholder: 'Size',
			required: false,
			value: 20,
			id: 'pageSize',
			type: 'pageSize',
		},
	],
};
